import { useState } from "react";
import { scheduleDays } from "@/mocks/content";

export default function ScheduleSection() {
  const defaultIndex = scheduleDays.findIndex((d) => d.highlight);
  const [active, setActive] = useState(defaultIndex >= 0 ? defaultIndex : 0);
  const current = scheduleDays[active];

  return (
    <section id="schedule" className="w-full bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div>
          <span className="font-label text-sm font-medium text-accent-400">追更不迷路</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            追更日历 · 一周更新安排
          </h2>
          <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-background-200">
            韩剧大多采用每周两集的播出节奏。下面是本站整理的本周更新安排，点击星期查看当天上线与放送时间，
            提前把想追的剧排进日程。
          </p>
        </div>

        <div className="mt-8 flex gap-2 overflow-x-auto pb-2">
          {scheduleDays.map((item, index) => (
            <button
              key={item.day}
              type="button"
              onClick={() => setActive(index)}
              aria-pressed={active === index}
              className={`flex min-w-[84px] flex-col items-center gap-1 whitespace-nowrap rounded-lg border px-4 py-3 transition-colors ${
                active === index
                  ? "border-accent-500 bg-accent-500 text-foreground-950"
                  : "border-background-50/15 text-background-100 hover:border-accent-400/60"
              }`}
            >
              <span className="font-heading text-base font-bold">{item.day}</span>
              <span
                className={`font-label text-[11px] ${active === index ? "text-foreground-900" : "text-background-300"}`}
              >
                {item.shows.length} 部更新
              </span>
              {item.highlight && (
                <span
                  className={`h-1.5 w-1.5 rounded-full ${
                    active === index ? "bg-foreground-900" : "bg-accent-400"
                  }`}
                ></span>
              )}
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-lg border border-background-50/15 bg-background-50/5 p-4 md:p-6">
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line text-accent-400" aria-hidden="true"></i>
            <h3 className="font-heading text-lg font-semibold text-background-50">
              {current.day} 更新剧集
            </h3>
          </div>
          <ul className="mt-4 space-y-3">
            {current.shows.map((show) => (
              <li
                key={show.title}
                className="flex flex-col gap-2 rounded-md border border-background-50/10 bg-background-50/5 p-3 sm:flex-row sm:items-center sm:justify-between"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500/90 font-heading text-sm font-bold text-foreground-950">
                    {show.tag.slice(0, 1)}
                  </span>
                  <div>
                    <p className="font-heading text-sm font-semibold text-background-50">{show.title}</p>
                    <p className="mt-0.5 font-label text-xs text-background-300">{show.info}</p>
                  </div>
                </div>
                <span className="self-start rounded-full bg-background-50/10 px-3 py-1 font-label text-xs text-background-100 sm:self-auto">
                  {show.tag}
                </span>
              </li>
            ))}
          </ul>
          <p className="mt-4 font-body text-xs leading-relaxed text-background-300">
            提示：播出时间可能因平台排播调整而变化，实际更新请以平台页面为准。
          </p>
        </div>
      </div>
    </section>
  );
}